export default function isWindow(obj) {
  /* eslint no-eq-null: 0 */
  /* eslint eqeqeq: 0 */
  return obj != null && obj == obj.window;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-align/es/isWindow.js
// module id = 397
// module chunks = 0 1